<template>
  <div>
    <overlay :value="loading"></overlay>
    <v-card class="pa-6">
      <v-card-title class="text-uppercase">
        <v-row class="my-1 justify-space-between align-center">
          <div>{{ this.attachmentType === null ? 'Crear nuevo' : 'Editar' }} tipo de adjunto</div>
        </v-row>
      </v-card-title>
      <hr class="my-3" />
      <v-card-text class="my-0 py-0">
        <v-form ref="newAttachmentTypeForm" v-model="formValid">
          <v-container class="ma-0 pa-0">
            <v-col class="ma-0 pa-0">
              <v-row class="mt-1 mb-n5">
                <v-col cols="12">
                  <v-text-field
                    label="Nombre"
                    v-model="newAttachmentType.name"
                    required
                    outlined
                    dense
                    :rules="nameRules"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="my-1">
                <v-col cols="12">
                  <v-text-field
                    label="Descripción"
                    v-model="newAttachmentType.description"
                    outlined
                    dense
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="my-1">
                <v-col cols="12">
                  <v-text-field
                    label="URL de plantilla"
                    v-model="newAttachmentType.template_url"
                    outlined
                    dense
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="my-1">
                <v-col cols="12">
                  <v-switch
                    class="mt-0 pt-0"
                    label="Obligatorio"
                    v-model="newAttachmentType.required"
                    hide-details="auto"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-col>
          </v-container>
        </v-form>
      </v-card-text>
      <hr class="my-3" />
      <v-card-actions class="justify-end">
        <v-btn text color="primary" rounded @click="closeDialog">Cerrar</v-btn>
        <v-btn :disabled="!formValid" color="primary" rounded @click="validate">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="error" :timeout="5000">
      {{ errorMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="error = false"> Entendido </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Overlay from '../components/Overlay.vue';
import AttachmentTypesService from '../services/attachment-types.service';

export default {
  components: { Overlay },
  name: 'AttachmentTypeMaintainer',
  props: ['attachmentType'],
  data() {
    return {
      loading: false,
      error: false,
      errorMessage: '',
      newAttachmentType: {},
      formValid: false,
      nameRules: [v => !!v || 'El campo es requerido']
    };
  },
  mounted() {
    this.newAttachmentType = {};
    this.parseAttachmentType(this.attachmentType !== null);
  },
  watch: {
    attachmentType(val) {
      this.newAttachmentType = {};
      this.$refs.newAttachmentTypeForm.resetValidation();
      this.parseAttachmentType(val !== null);
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close-dialog');
    },
    parseAttachmentType(exist) {
      this.newAttachmentType.id = exist ? this.attachmentType.id : null;
      this.newAttachmentType.name = exist ? this.attachmentType.name : '';
      this.newAttachmentType.description = exist ? this.attachmentType.description || '' : '';
      this.newAttachmentType.template_url = exist ? this.attachmentType.template_url || '' : '';
      this.newAttachmentType.required = exist ? this.attachmentType.required : true;
      this.$nextTick(() => {
        if (this.$refs.newAttachmentTypeForm) this.$refs.newAttachmentTypeForm.validate();
      });
    },
    validate() {
      if (this.$refs.newAttachmentTypeForm.validate()) {
        if (this.attachmentType === null) {
          this.createAttachmentType();
        } else {
          this.updateAttachmentType();
        }
      }
    },
    buildPayload() {
      return {
        name: this.newAttachmentType.name.trim(),
        description: this.newAttachmentType.description.trim() || null,
        template_url: this.newAttachmentType.template_url.trim() || null,
        required: this.newAttachmentType.required
      };
    },
    async createAttachmentType() {
      this.loading = true;
      const res = await AttachmentTypesService.create(this.buildPayload());
      if (res.status === 'ok') {
        this.$refs.newAttachmentTypeForm.resetValidation();
        this.$emit('update-list');
        this.closeDialog();
      } else {
        this.errorMessage = res.message || 'No se pudo crear el tipo de adjunto, intenta más tarde';
        this.error = true;
      }
      this.loading = false;
    },
    async updateAttachmentType() {
      this.loading = true;
      const res = await AttachmentTypesService.update(this.newAttachmentType.id, this.buildPayload());
      if (res.status === 'ok') {
        this.$refs.newAttachmentTypeForm.resetValidation();
        this.$emit('update-list');
        this.closeDialog();
      } else {
        this.errorMessage = res.message || 'No se pudo actualizar el tipo de adjunto, intenta más tarde';
        this.error = true;
      }
      this.loading = false;
    }
  }
};
</script>
